import { useEffect } from 'react';
import { useAuth } from '../context/AuthContext';

/**
 * Hook to set dynamic page title.
 * Format: "Protección Industrial — {empresa.nombre_corto} | {pageTitulo}"
 * Without user: just "Protección Industrial"
 */
export default function usePageTitle(titulo) {
    const { user, empresa } = useAuth();

    useEffect(() => {
        const base = 'Protección Industrial';
        if (!user) {
            document.title = base;
            return;
        }
        const empresaNombre = empresa?.nombre_corto || empresa?.nombre || '';
        const parts = [base];
        if (empresaNombre) parts.push(empresaNombre);
        if (titulo) parts.push(titulo);
        // "Protección Industrial — MLP | Todas las Guías"
        document.title = parts.length === 1
            ? base
            : `${parts[0]} — ${parts.slice(1).join(' | ')}`;
    }, [titulo, user, empresa]);
}
